/**
 * @Author:
 * @Description:
 * @DateTime: Created in 22:21 2018/11/21
 */
import Api from '../../util/api';
import { Result } from '../../types/base';
import qs from 'qs';
import RouteUtils from 'src/util/routeUtils';
import LocalStore from 'src/util/LocalStore';
export namespace LoginDOI {
    export interface LoginResultI {
        access_token: string;
        expires: number;
        real_name: string;
        role_id: number,
        refresh_token: string;
        user_id: number;
        username: string;
        system_name: string;
        english_system_name: string;
        logo_url: string;
    }
}
export default class LoginApi {
    static async login(data: { passwords: string; username: string }): Promise<Result<LoginDOI.LoginResultI>> {
        return Api.post('/auth_login/login', data);
    }

    /**
     * 获取验证码
     */
    static async getCode(mobile: string): Promise<Result<string>> {
        return Api.post('/auth_login/mobile/code/get', { mobile });
    }

    /**
     * 重置密码
     */
    static async update(data: { mobile: string; passwords: string; code: string }): Promise<Result<any>> {
        return Api.post('/auth_login/mobile/password/find', data);
    }

    static async refresh(refresh_token: string): Promise<Result<{ refresh_token: string; access_token: string; expires: number }>> {
        return Api.post('/auth_verify/refresh_token/refresh', { refresh_token });
    }
}

export async function refreshToken(): Promise<any> {
    let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
    if (!userInfo || !userInfo.access_token) {
        return  ;
    }
    let { code, data } = await LoginApi.refresh(userInfo.refresh_token);
    if (code === 0) {
        userInfo = { ...userInfo, ...data };
        LocalStore.setData('userInfo', userInfo);
        loopRequestToken()
        return ;
    } else {
        return ;
    }
}

let itv
export async function loopRequestToken() {
    clearInterval(itv)
    // 过期前5份中调用刷新token
    itv = setInterval(async () => {
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        if(userInfo.expires * 1000 - Date.now() > 5 * 60 * 1000) {
            return
        }
        let { code, data } = await LoginApi.refresh(userInfo.refresh_token);
        if (code === 0) {
            userInfo = { ...userInfo, ...data };
            LocalStore.setData('userInfo', userInfo);
            loopRequestToken()
        } else {
            RouteUtils.goTo('/login');
        }
    }, 60 * 1000);
}
